import React from 'react';

import { observer } from 'mobx-react';

import { isFileImage } from 'ui/files';

import { humanFileSize } from 'utils/formatters/file';

import {
  FileUploadProgressContainer,
  StyledLinearProgress,
  FileDetailsContainer,
  StyledClearIcon,
  FileNameText,
  FilePropertiesContainer,
  FileSizeText,
  FileControlsContainer,
  FileProgressText,
  Thumbnail,
} from './styles';
import { FileUploadProgressProps } from './types';
import Item from '../Item';
import AttachmentIcon from '../../Icons/AttachmentVertical';

const FileUploadProgress: React.FunctionComponent<FileUploadProgressProps> = ({ activity, sessionUser }) => {
  const isImage = isFileImage(activity.name);

  const progress = (activity.loaded / activity.size) * 100;
  const invertColors = isImage && progress < 100;

  return (
    <Item activity={activity} sessionUser={sessionUser}>
      <FileUploadProgressContainer invertColors={invertColors}>
        <FileDetailsContainer>
          {!isImage ? <AttachmentIcon style={{ alignSelf: 'auto' }} /> : null}
          <FilePropertiesContainer>
            {isImage && progress < 100 ? (
              <Thumbnail thumbnail={activity.thumbnail}>
                <img src="/spinner.gif" alt="upload progress spinner" width={30} height={30} />
              </Thumbnail>
            ) : null}
            <FileNameText invertColors={invertColors}>{activity.name}</FileNameText>
            <FileSizeText invertColors={invertColors}>{humanFileSize(activity.size, true)}</FileSizeText>
          </FilePropertiesContainer>
          <FileControlsContainer>
            <StyledClearIcon invertColors={invertColors} onClick={activity.onCancel} />
            {progress >= 100 || !isImage ? (
              <FileProgressText $success={progress >= 100}>{Math.min(Math.ceil(progress), 100)}%</FileProgressText>
            ) : null}
          </FileControlsContainer>
        </FileDetailsContainer>
        <StyledLinearProgress
          value={Math.min((activity.loaded / activity.size) * 100, 100)}
          $success={progress >= 100}
        />
      </FileUploadProgressContainer>
    </Item>
  );
};

export default observer(FileUploadProgress);
